
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/board/new",
      function () {
        return require("private-next-pages/board/new/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/board/new"])
      });
    }
  